import styled from 'styled-components/macro'
import { respondAbove } from 'styles/mediaQueries'
import Text from 'components/shared/Text'

export const Wrapper = styled(Text)`
    br {
        display: none;

        @media ${respondAbove.xl} {
            display: inline;
        }
    }
`
